import { arrayOf, oneOf, shape } from 'prop-types'
import { PressureUnits } from '../../models/settings/pressure-units'
import { settingPropType } from './setting-prop-type'

/**
 * @typedef {Object} PressureUnitSetting
 * @property {Array<string>} [controlFlags]
 * @property {string} [name]
 * @property {Array<string>} [values]
 */
export const pressureUnitPropType = shape({
    ...settingPropType,
    values: arrayOf(oneOf(Object.values(PressureUnits)))
})
